import { useQuery } from '@tanstack/react-query';
import {
  getMetabaseSessionTokenViaSsoFlow,
  setMetabaseSessionToken,
} from '../../core/api';

type Options = {
  enabled?: boolean;
};

export const useGetMetabaseSessionToken = ({
  enabled = true,
}: Options = {}) => {
  return useQuery({
    queryKey: ['metabase-session-token'],
    queryFn: async () => {
      const token = await getMetabaseSessionTokenViaSsoFlow();

      setMetabaseSessionToken(token);

      return token;
    },
    enabled,
  });
};
